import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const WishlistContext = createContext(null);

const loadWishlist = () => {
  try {
    return JSON.parse(localStorage.getItem('aura-wishlist')) || [];
  } catch {
    return [];
  }
};

export function WishlistProvider({ children }) {
  const [savedIds, setSavedIds] = useState(loadWishlist);
  useEffect(() => localStorage.setItem('aura-wishlist', JSON.stringify(savedIds)), [savedIds]);
  const toggle = useCallback((productId) => setSavedIds((current) => current.includes(productId)
    ? current.filter((id) => id !== productId)
    : [...current, productId]), []);
  const isSaved = useCallback((id) => savedIds.includes(id), [savedIds]);
  const value = useMemo(() => ({ savedIds, toggle, isSaved }), [isSaved, savedIds, toggle]);
  return <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>;
}

export const useWishlist = () => useContext(WishlistContext);